export default "__VITE_ASSET__rTgAujd$__"